import { useAppStore } from '@/lib/app-store'

// False on the server and the first client render, so gating a control on it turns the pre-hydration dead
// window into an honest disabled state that Playwright's actionability wait already covers.
export function useHydrated(): boolean {
  return useAppStore((state) => state.hydrated)
}
